import { useState, useEffect } from 'react';
import styled from '@emotion/styled';

import DrawerDialog from './DrawerDialog';

// icons
import CloseIcon from '@mui/icons-material/CloseRounded';

import { Button, Tooltip, Divider, IconButton } from '@mui/material';

const DrawerTitle = styled.div`
  text-transform: uppercase;
  font-size: 1.4rem;
  font-weight: 600;
  color: ${props => props.theme.colors.mildText};
  flex-grow: 1;
  padding: 0 .5rem;
`
const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .5 1.1rem;
  margin-bottom: .5rem;
`;

const CloseButtonSection = styled.div`
  height: 100%;
  display: flex;
`;

const SideDrawer = ({ open, title, handleClose, children, ...props }) => {
  return (
    <DrawerDialog open={open} onClose={() => handleClose()}  minWidth='40rem' {...props} >
      <TopBar>
        <DrawerTitle>{title}</DrawerTitle>
        <CloseButtonSection>
          <Divider orientation="vertical" flexItem sx={{mx: 1, height: "100%"}} />
          <Tooltip title="Close"><IconButton onClick={() => handleClose()} size="small"><CloseIcon /></IconButton></Tooltip>
        </CloseButtonSection>
      </TopBar>
      <Divider sx={{mx: "-1rem"}} />
      {children}
    </DrawerDialog>
  )
};

export default SideDrawer;